import { render, staticRenderFns } from "./QuoteProductItemBody.vue?vue&type=template&id=34bba79e&"
import script from "./QuoteProductItemBody.vue?vue&type=script&lang=ts&"
export * from "./QuoteProductItemBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports